import { createSelector } from 'reselect';
import { IState } from './reducer';

const idSelector = (_: any, id: number) => id;
export const selector = (state: any) => state.noteLocator as IState;

export const isNoteMissing = createSelector(idSelector, selector, (id, state) => state.missingNoteIds.includes(id));



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/locator/selectors.tsx